module.exports = __webpack_public_path__ + "img/news4.ac6ede07.png";